module.exports = __webpack_public_path__ + "img/img18.bbfe9b46.jpg";